module.exports = __webpack_public_path__ + "static/media/jeremy_wacksman.a0962d3f.png";